export const managedSelectionTableClassNames = {
  cell: 'px-3 py-2',
  head: 'h-auto px-3 py-2',
  header: 'bg-muted/40 text-muted-foreground',
  row: 'hover:bg-transparent',
} as const;
